export default (() => ({
  icon: {
    regular: '24px',
    small: '18px'
  }
}));